import TableContainer from '@mui/material/TableContainer';

export { TableContainer };
